import { ConfigEntryType } from 'config/config';
import AddLineIcon from 'remixicon-react/AddLineIcon';
import { useParams } from 'react-router-dom';
import { Title, TitleContainer, TreeItem } from './RetroPhase';
import { Box, Button, IconButton } from '@mui/material';
import { theme } from 'config/theme';
import { useProjectRetroContext } from '../../context';
import { useFormContext } from 'react-hook-form';
import { PostFormData } from '@buildwise/pages/addPost/hooks/useAddPostForm';
import { getArticleFormDefaultValues } from '@buildwise/libs/posts';
import useProjectDetailsQuery from '@buildwise/pages/project/hooks/useProjectDetailsQuery';
import LessonsTable from './LessonsTable';
import { useMemo } from 'react';
import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';
import ArrowRightSLineIcon from 'remixicon-react/ArrowRightSLineIcon';
import ArrowRightLineIcon from 'remixicon-react/ArrowRightLineIcon';

type RetroCategoryProps = {
  category: string;
  phase: ConfigEntryType;
  showCategoryTree: boolean;
};

function RetroCategory({ category, phase, showCategoryTree }: RetroCategoryProps) {
  const { projectId = '' } = useParams();
  const {
    state: { selectedLessonType },
  } = useProjectRetroContext();
  const { projectArticles, isLoading } = useProjectDetailsQuery({
    projectId,
    shouldFetch: false,
  });
  const lessons = useMemo(
    () =>
      projectArticles.filter(
        ({ lessonTypes }) =>
          !selectedLessonType?.id ||
          lessonTypes?.includes(selectedLessonType.id) ||
          (!lessonTypes && selectedLessonType.id === 'Blank'),
      ),
    [projectArticles, selectedLessonType],
  );
  const {
    state: { articleFields, isOpenedLessonForm, selectedArticle },
    dispatch,
  } = useProjectRetroContext();
  const { reset, getValues } = useFormContext<PostFormData>();
  const { projectPhases, projectMileStones } = getValues();

  return (
    <TreeItem
      key={category}
      nodeId={category}
      sx={(theme) => ({
        '& .MuiTreeItem-content': {
          ...(!selectedArticle &&
            isOpenedLessonForm &&
            projectPhases === phase.entryCode &&
            projectMileStones === category && {
              bgcolor: `${theme.palette.custom.aliceBlue} !important`,
            }),
        },
      })}
      label={
        <>
          <TitleContainer
            sx={(theme) => ({
              gap: 1,
              p: 1,
              '&: hover': {
                backgroundColor: theme.palette.custom.background,
              },
            })}
            onClick={(event) => {
              event.stopPropagation();
              reset({
                ...getArticleFormDefaultValues({
                  defaultProjectId: projectId,
                  articleFields,
                }),
                projectPhases: phase.entryCode,
                projectMileStones: category,
                projectSpecific: true,
              });
              dispatch(({ state }) => ({
                payload: {
                  ...state,
                  isOpenedLessonForm: true,
                  selectedArticle: undefined,
                  articleIds: [],
                  showSelectMilestone: false,
                },
              }));
            }}
          >
            <Title
              sx={{
                fontWeight: 400,
                fontSize: 15,
              }}
            >
              {category}
            </Title>
            {/* <Button
              variant="text"
              size="small"
              startIcon={<AddLineIcon size={18} />}
              sx={(theme) => ({
                color: theme.palette.custom.link,
              })}
              onClick={(event) => {
                event.stopPropagation();
                reset({
                  ...getArticleFormDefaultValues({
                    defaultProjectId: projectId,
                    articleFields,
                  }),
                  projectPhases: phase.entryCode,
                  projectMileStones: category,
                  projectSpecific: true,
                });
                dispatch(({ state }) => ({
                  payload: {
                    ...state,
                    isOpenedLessonForm: true,
                    selectedArticle: undefined,
                    articleIds: [],
                  },
                }));
              }}
            >
              Add New
            </Button> */}
          </TitleContainer>
        </>
      }
      onClick={(event) => event.preventDefault()}
      expandIcon={
        <IconButton size="small">
          <ArrowRightSLineIcon size={22} color={theme.palette.custom.darkJungleGreen} />
        </IconButton>
      }
      collapseIcon={
        <IconButton size="small">
          <ArrowDownSLineIcon size={22} color={theme.palette.custom.darkJungleGreen} />
        </IconButton>
      }
    >
      {showCategoryTree && (
        <Box mt={0.5}>
          {lessons.length > 0 && <LessonsTable lessons={lessons} isLoading={isLoading} />}
        </Box>
      )}
    </TreeItem>
  );
}

export default RetroCategory;
